// eslint-disable-next-line no-restricted-imports
import {
  UpdateOrderDto_Input,
  Query_OrderController_GetById_ExecutionTerms_OperationKind,
  Query_OrderController_GetById_ExecutionTerms_OrderType,
  OrderDetailsDto_Input,
} from 'api/generated/graphql';
import { OrderDetailsParams, UpdateOrderParams } from 'api/types/params';
import { formatToISODate } from 'helpers';

type ApiParams = Omit<UpdateOrderDto_Input, 'versionNumber'>;

const parseDetails = (details: OrderDetailsParams): OrderDetailsDto_Input => ({
  accountNumber: details.accountNumber,
  brokerName: details.brokerName,
  custodianOrganization: details.custodianOrganization,
  accountOwnerName: details.accountOwnerName,
  custodianOrganizationCode: details.custodianOrganizationCode,
});

export const parseUpdateOrderParams = (
  params: UpdateOrderParams
): ApiParams => ({
  endDate: formatToISODate(params.endDate),
  executionPeriodInBusinessDays: params.executionPeriodInBusinessDays,
  executionTerms: {
    additionalNotes: params.executionTerms.additionalNotes,
    orderType: params.executionTerms.orderType
      ? Query_OrderController_GetById_ExecutionTerms_OrderType[
          params.executionTerms.orderType
        ]
      : undefined,
    yield: params.executionTerms.yield,
    operationKind: params.executionTerms.operationKind
      ? Query_OrderController_GetById_ExecutionTerms_OperationKind[
          params.executionTerms.operationKind
        ]
      : undefined,
    operationPurpose: params.executionTerms.operationPurpose,
  },
  financialInstrument: {
    isin: params.financialInstrument.isin,
    securityType: params.financialInstrument.securityType,
    issuer: params.financialInstrument.issuer,
    nominalValue: params.financialInstrument.nominalValue,
  },

  transactionVolume: params.transactionVolume
    ? {
        quantity: params.transactionVolume.quantity,
        unitPrice: params.transactionVolume.unitPrice,
        currency: params.transactionVolume.currency,
        transactionAmount: params.transactionVolume.transactionAmount,
      }
    : undefined,

  transferVolume: params.transferVolume
    ? {
        quantity: params.transferVolume.quantity,
        unitPrice: params.transferVolume.unitPrice,
        currency: params.transferVolume.currency,
        transactionAmount: params.transferVolume.transactionAmount,
      }
    : undefined,

  senderDetails: params.senderDetails
    ? parseDetails(params.senderDetails)
    : undefined,

  recipientDetails: params.recipientDetails
    ? parseDetails(params.recipientDetails)
    : undefined,

  additionalParameters: params.additionalParameters
    ? {
        settlementDate: params.additionalParameters.settlementDate
          ? formatToISODate(params.additionalParameters.settlementDate)
          : null,
        transactionDate: params.additionalParameters.transactionDate
          ? formatToISODate(params.additionalParameters.transactionDate)
          : null,
      }
    : undefined,

  confirmationDocument: params.confirmationDocument
    ? {
        fileIds: params.confirmationDocument.fileIds,
        contractDate: params.confirmationDocument.contractDate
          ? formatToISODate(params.confirmationDocument.contractDate)
          : undefined,
        contractNumber: params.confirmationDocument.contractNumber,
      }
    : undefined,
});
